module.exports = __webpack_public_path__ + "static/media/pexels-photo-212286.1650eab6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/common/app2soft/images/001_fe/pexels-photo-212286.jpg
// module id = 764
// module chunks = 0